import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BiAddToQueue } from 'react-icons/bi';
import { Modal, Button } from 'react-bootstrap';
import cn from 'classnames';
import { Location } from 'services/action';

import { FormLocations } from 'ui/screens/authorized/_shared/modal/form.location.single';
import BulkImport from '../../../location/component/bulk';
import SingleInput from '../../../location/component/single';
import { FormBulkUpdate } from '../../../location/component/form';
import TableImport from '../../../location/component/tabel.import';

const initialState = {
  showCreate: false,
  datas: [],
  types: null,
  update: null,
  forms: null,
};

const ActionCreate = ({ onClose, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ showCreate, datas, update, types, forms }, setState] =
    React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showCreate: false,
      datas: [],
      update: null,
      types: null,
      forms: null,
    }));

    onClose();
  };

  const $handleUpdate = async (d, id) => {
    const u = { id: id, data: datas[id] };
    setState((prevState) => ({
      ...prevState,
      update: u,
    }));
  };

  const $handleDelete = async (id) => {
    let newList = [...datas];
    newList.splice(id, 1);
    setState((prevState) => ({
      ...prevState,
      datas: newList,
      update: null,
    }));
  };

  const $onUpdate = async (d) => {
    let newList = [...datas];
    newList[update?.id] = d;

    setState((prevState) => ({
      ...prevState,
      datas: newList,
      update: null,
    }));
  };

  const $bulkSave = async (c) => {
    const payload = {
      customer_id: data?.id,
      datas: datas,
      type: 'drop_point',
    };

    const req = await Dispatch(Location.$createBulk(payload));

    if (req?.message === 'success') {
      $handleClose();
    }
  };

  const $singleSave = async (c) => {
    const payload = {
      ...forms,
      type: 'drop_point'
    };
    const req = await Dispatch(Location.$create(payload));

    if (req?.message === 'success') {
      $handleClose();
    }
  };

  const $handleSubmit = async () => {
    if (types === 'single') {
      $singleSave();
    } else if (types === 'bulk_import') {
      $bulkSave();
    }
  };

  return (
    <div>
      <button
        onClick={() =>
          setState((prevState) => ({ ...prevState, showCreate: true }))
        }
        className="btn btn-primary px-2"
      >
        <BiAddToQueue color="white" size="14" />
        <span className="d-none d-md-block ms-1">Tambah Lokasi</span>
      </button>

      <Modal
        show={showCreate}
        onHide={$handleClose}
        backdrop="static"
        centered
        scrollable
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Buat Lokasi</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {(types === null ||
            (types === 'bulk_import' && datas?.length) === 0) && (
            <div className="row border bg-white m-0">
              <div className="col-md-5 border-bottom-sm d-flex justify-content-center align-items-center">
                <BulkImport
                  onImported={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      datas: [...prevState?.datas, e],
                      types: 'bulk_import',
                      update: null,
                    }))
                  }
                />
              </div>
              <div className="col-md-2 d-flex justify-content-center align-items-center  position-relative">
                <div
                  className="position-absolute top-50 start-50 translate-middle d-none d-md-flex"
                  style={{
                    height: 150,
                    width: 0.5,
                    backgroundColor: '#848484',
                  }}
                />
                <div
                  className="rounded-circle bg-white d-flex justify-content-center align-items-center fs-8 text-uppercase fw-bold text-grey"
                  style={{
                    width: 70,
                    height: 70,
                    zIndex: 9,
                    border: '1px solid #848484',
                  }}
                >
                  atau
                </div>
              </div>
              <div className="col-md-5  d-flex justify-content-center align-items-center">
                <SingleInput
                  onPress={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      types: 'single',
                      datas: [],
                      update: null,
                    }))
                  }
                />
              </div>
            </div>
          )}

          {types === 'bulk_import' && datas?.length > 0 && (
            <div>
              {update ? (
                <FormBulkUpdate
                  data={update?.data}
                  onSubmit={$onUpdate}
                  onClose={() => {
                    setState((prevState) => ({ ...prevState, update: null }));
                  }}
                />
              ) : null}

              <div className="mt-3">
                <TableImport
                  data={datas}
                  onDelete={$handleDelete}
                  onUpdate={$handleUpdate}
                />
              </div>
            </div>
          )}

          {types === 'single' && (
            <FormLocations
              onFormChange={(e) =>
                setState((prevState) => ({ ...prevState, forms: e }))
              }
              customer_id={data?.id}
              type="customer"
            />
          )}
        </Modal.Body>

        {types === 'single' ||
        (types === 'bulk_import' && datas?.length > 0) ? (
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  type="button"
                  className="btn btn-light w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  type="button"
                  className={cn(
                    StateForm?.loading ? 'btn-loading' : '',
                    'btn btn-primary w-100'
                  )}
                  disabled={StateForm?.loading}
                  onClick={$handleSubmit}
                >
                  Simpan
                </Button>
              </div>
            </div>
          </Modal.Footer>
        ) : null}
      </Modal>
    </div>
  );
};

export default ActionCreate;
